import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

export const DIALOG_AI_ADD_TO_CART_ERROR = 'DIALOG_AI_ADD_TO_CART_ERROR'

const styles = stylex.create({
  content: {
    paddingBlock: '12px',
  },
  button: {
    backgroundColor: colors.black,
  },
})

export const DialogAiAddToCartError = () => {
  const { open, closeDialog } = useDialog(DIALOG_AI_ADD_TO_CART_ERROR)
  return (
    <Dialog
      maxWidth={320}
      open={open}
    >
      <DialogHeader title="需加入商品" onClose={closeDialog} />
      <DialogContent rootStyle={styles.content}>
        <Text>加入採購失敗！需最少選擇 1 個商品，才能加入採購</Text>
      </DialogContent>
      <DialogActions>
        <Button rootStyle={styles.button} fullWidth onClick={closeDialog}>我知道了</Button>
      </DialogActions>
    </Dialog>
  )
}
